import * as React from 'react'
import Typography from '@mui/material/Typography'
import Modal from '@mui/material/Modal'
import { Box, Button, Card, CardContent, Divider, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import styles from './SessionDeletePopup.module.scss'

const SessionDeletePopup: React.FC<{
  openDeletePopup: boolean
  handleClose: () => void
  sessionDeleteHandle: () => void
}> = ({
  openDeletePopup,
  handleClose,
  sessionDeleteHandle
}) => {
  return (
      <Modal
        open={openDeletePopup}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Card className={styles.sessionDeleteOuterCard}>
          <Box sx={{ padding: '1rem' }} display='flex' justifyContent='space-between'>
            <Typography id="modal-modal-title" fontWeight={600} fontSize='1rem'>
              Delete Session
            </Typography>
            <IconButton onClick={handleClose} aria-label="delete" size="small">
              <CloseIcon />
            </IconButton>
          </Box>
          <Divider variant="fullWidth" />
          <CardContent>
            <Card sx={{ border: '1px solid #EEA23E', padding: '1rem', backgroundColor: '#FFF8EB' }}>
              <Box display='flex' alignItems='center'>
                <Typography ml='0.5rem' id="modal-modal-title" variant="body1" component="h2">
                 Are you sure you want to delete this session?
                </Typography>
              </Box>
            </Card>
          </CardContent>
          <Divider variant="fullWidth" />
          <Box sx={{ padding: '1rem' }} display='flex' justifyContent='end' gap={2}>
            <Button
              onClick={handleClose}
              sx={{
                textTransform: 'none'
              }}
              color='secondary'
              variant="contained">Cancel</Button>
            <Button
              onClick={() => { sessionDeleteHandle() }}
              sx={{
                textTransform: 'none'
              }}
              color='primary'
              variant="contained">Delete</Button>
          </Box>

        </Card>
      </Modal>
  )
}

export default SessionDeletePopup
